import { z } from 'zod';

// === Company Schema ===

export const SUBSCRIPTION_STATUSES = ['active', 'past_due', 'canceled'] as const;

export const SubscriptionStatus = z.enum(SUBSCRIPTION_STATUSES);
export type SubscriptionStatus = z.infer<typeof SubscriptionStatus>;

export const CompanySchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1).max(255),
  subscription_status: SubscriptionStatus,
  stripe_customer_id: z.string().nullable(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export type Company = z.infer<typeof CompanySchema>;

export const CompanyInsertSchema = CompanySchema.omit({
  id: true,
  created_at: true,
  updated_at: true,
});
export type CompanyInsert = z.infer<typeof CompanyInsertSchema>;

export const CompanyUpdateSchema = CompanySchema.partial().required({ id: true });
export type CompanyUpdate = z.infer<typeof CompanyUpdateSchema>;

// === User Profile Schema ===

export const USER_ROLES = ['superadmin', 'admin', 'user'] as const;

export const UserRole = z.enum(USER_ROLES);
export type UserRole = z.infer<typeof UserRole>;

export const ProfileSchema = z.object({
  id: z.string().uuid(),
  company_id: z.string().uuid().nullable(),
  full_name: z.string().nullable(),
  role: UserRole,
  permissions: z.array(z.string()),
  updated_at: z.string().datetime(),
});

export type Profile = z.infer<typeof ProfileSchema>;
